import React from 'react'
import posed, { PoseGroup} from 'react-pose'
import styled from 'styled-components'
import { Link } from "gatsby"

const SlideControlPose = posed.ul({
  enter: {
    x: -20,
    opacity: 1,
    staggerChildren: 100,
  },
  exit: {
    x: 0,
    opacity: 0,
    staggerChildren: 100,
  }
});

const SlideControlWrapper = styled(SlideControlPose)`
  position: absolute;
  bottom: 20px;
  right: 3px;
  cursor: pointer;
  z-index: 100;
  color: white;
  list-style: none outside none;
  margin: 0;
  padding: 0;
  @media (min-width: 1024px) {
    position: fixed;
  }
`

const LabelPose = posed.span({
  enter: {
    x: -20,
    opacity: 0
  },
  exit: {
    x: 0,
    opacity: 0
  }
});

const LabelWrapper = styled(LabelPose)`
  display: inline-block;
  float: left;
  vertical-align: middle;
  font-size: 15px;
  line-height: 1;
  margin-right: 10px;
  transition: opacity .25s ease-in-out;
  text-transform: uppercase;
  color: white;
  text-shadow: 0 0 2px #2a2a2a;
`

const PointPose = posed.span({
  enter: {
    x: -20,
    opacity: 1
  },
  exit: {
    x: 0,
    opacity: 0
  },
  hoverable: true,
  init: { scale: .6 },
  hover: { scale: 1 }
});

const PointWrapper = styled(PointPose)`
  height: 15px;
  width: 15px;
  background: white;
  display: inline-block;
  float: right;
  vertical-align: middle;
  margin-bottom: 15px !important;
`

const Item = styled.li`
  clear: both;
`

const LinkWrapper = styled(Link)`
  &.active > .slide-control-point {
    transform: translateX(-20px) scale(1) translateZ(0px) !important;
  }
  > .slide-control-label.hover {
    opacity: 1 !important;
  }
`

const LinkBlock = props => (
    <Item>
      <LinkWrapper to={props.to} activeClassName="active">
        <LabelWrapper className={props.isHover ? "slide-control-label hover font-mono" : "slide-control-label font-mono"}>{props.label}</LabelWrapper>
        <PointWrapper onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} className="slide-control-point"></PointWrapper>
      </LinkWrapper>
    </Item>
)

class Button extends React.Component {
  state = { isVisible: false, isHover: false };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }, 1500);
    /*
    setInterval(() => {
      this.setState({
        isVisible: !this.state.isVisible
      });
    }, 1000);
    */
  }

  onMouseOver = (e) => {
    this.setState({ isHover: true })
  }

  onMouseOut = (e) => {
    this.setState({ isHover: false })
  }

  render() {
    const { isVisible, isHover } = this.state;

    return(
      <PoseGroup>
        {isVisible
          ? <SlideControlWrapper key="slideControl" className="hidden lg:block">
              <LinkBlock
                to="/"
                label="Home"
                isHover={isHover}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              />
              <LinkBlock
                to="/about"
                label="About"
                isHover={isHover}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              />
              <LinkBlock
                to="/services"
                label="Services"
                isHover={isHover}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              />
              <LinkBlock
                to="/knowledge"
                label="Knowledge"
                isHover={isHover}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              />
            </SlideControlWrapper>
          : null}
      </PoseGroup>
    )
  }
}



export default Button
